<script setup>
import PublicNavBar from "@/components/Layout/PublicNavBar.vue";
import ANotification from "@/components/AComponents/ANotification.vue";
import {useNotificationStore} from "@/stores/notifications.js";

const notificationStore = useNotificationStore();
</script>

<template>
  <public-nav-bar />

  <main class="min-h-screen pt-[5%] bg-neutral-400">
    <slot></slot>
  </main>

  <div class="fixed bottom-8 right-8 z-9999">
    <a-notification v-for="notification in notificationStore.notifications"
                    :notification="notification"
                    :key="notification.id" />
  </div>
</template>
